import { inject, injectable } from 'inversify';
import TwilioVerificationRepository from 'src/features/verification/data/TwilioVerificationRepository';
import { TwilioSendVerificationCodeParams } from 'src/features/verification/data/service/TwilioVerificationService.types';
import { SendOtpUseCaseInterface } from 'src/features/verification/domain/useCases/types';

@injectable()
class SendOtpUseCase implements SendOtpUseCaseInterface {
  @inject(TwilioVerificationRepository)
  private twilioRepository!: TwilioVerificationRepository;

  async execute(params: TwilioSendVerificationCodeParams) {
    return this.twilioRepository.sendVerificationCode(params);
  }
}

export default SendOtpUseCase;
